import React, { useState, useEffect, useRef } from 'react'
import HStack from './HStack'
import VStack from './VStack'
import Data from './data/Data'

import intro_small from './images/intro_small.webp'
import intro_medium from './images/intro_medium.webp'
import intro_large from './images/intro_large.webp'

const theme = Data.theme

const componentStyles = {
    small: {
        textContainer: {
            root: {
                padding: '30px 20px',
            }
        },
        innerTextContainer: {
            root: {
                alignItems: 'center'
            }
        },
        imageContainer: {
            root: {
                padding: 0,
            }
        },
        buttonContainer: {
            root: {
                alignSelf: 'center',
                background: Data.theme.colours.primaryAlt2,
                margin: '30px 0',
                borderRadius: 5,
                //padding: '10px 20px',
                color: 'white',
                cursor: 'pointer'
            }
        },
        headerText: { fontSize: 32, fontWeight: 500, lineHeight: '150%', color: theme.colours.text },
        detailText: { fontSize: 16, lineHeight: '150%', paddingTop: 10, color: theme.colours.text },
        buttonText: { fontSize: 16, lineHeight: '150%', color: 'white' },
    },
    medium: {
        textContainer: {
            root: {
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                width: '50%',
                height: '100%',
            }
        },
        innerTextContainer: {
            root: {
                maxWidth: 300,
                top: 50
            }
        },
        imageContainer: {
            root: {
                padding: '80px 0',
            }
        },
        buttonContainer: {
            root: {
                alignSelf: 'start',
                background: Data.theme.colours.primaryAlt2,
                margin: '20px 0',
                borderRadius: 5,
                //padding: '10px 20px',
                color: 'white',
                cursor: 'pointer'
            }
        },
        headerText: { fontSize: 32, fontWeight: 500, lineHeight: '150%', color: theme.colours.text },
        detailText: { fontSize: 16, lineHeight: '150%', paddingTop: 20, color: theme.colours.text },
        buttonText: { fontSize: 16, lineHeight: '150%', color: 'white' },
    },
    large: {
        textContainer: {
            root: {
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                width: '50%',
                height: '100%',
            }
        },
        innerTextContainer: {
            root: {
                width: 350,
                top: 50
            }
        },
        imageContainer: {
            root: {
                padding: '80px 0',
            }
        },
        buttonContainer: {
            root: {
                alignSelf: 'start',
                background: Data.theme.colours.primaryAlt2,
                margin: '20px 0',
                borderRadius: 5,
                //padding: '10px 20px',
                color: 'white',
                cursor: 'pointer'
            }
        },
        headerText: { fontSize: 36, fontWeight: 500, lineHeight: '150%', color: theme.colours.text },
        detailText: { fontSize: 16, lineHeight: '150%', paddingTop: 20, color: theme.colours.text },
        buttonText: { fontSize: 16, lineHeight: '150%', color: 'white' },
    }
}

export default function Intro(props) {
    const {
        size = 'large',
        homeRef,
        menuSelectCallback,
    } = props

    const cStyles = componentStyles[size] ?? {}
    const intro = size === 'small' ? intro_small : size === 'large' ? intro_large : intro_medium

    return (
        <>
            <VStack stackRef={homeRef} grow={1} styles={cStyles.imageContainer}>
                <img src={intro} alt='intro' style={{
                    background: 'white', borderRadius: '0%', width: '100%', opacity: '1',
                    //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
                }} />
            </VStack>
            <VStack styles={cStyles.textContainer}>
                <VStack styles={cStyles.innerTextContainer}>
                    <VStack style={{ display: 'flex', flexDirection: size === 'small' ? 'row' : 'column',  }}>
                        <span style={cStyles.headerText}>Natural keys to health</span>
                    </VStack>
                    <span style={cStyles.detailText}>
                        We offer comprehensive healthcare services through acupuncture and Chinese herbal medicine. 
                        Our dedication is centered on delivering healthcare of exceptional quality.
                    </span>
                    <VStack styles={cStyles.buttonContainer}>
                        <div onClick={handleAppointentSelected} style={{padding: '10px 20px',cursor: 'pointer'}}>
                        <span style={cStyles.buttonText}>Book an appointment</span>
                        </div>
                    </VStack>
                </VStack>
            </VStack>
        </>
    )

    function handleAppointentSelected() {
        console.log('book')
        if (menuSelectCallback) {
            menuSelectCallback('appointments')
        }
    }
}